import { Box, Grid, styled, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import TurnoPromiseComponent from "../../SDK/FAQ/turnoPromiseComponent";
import { getCookie } from "../../utils/cookie";
import VehicleLoan from "../Home/HomePageRevamp/vehicleLoan";
import MemoizedCustomerVehicleCard from "./VehicleCard2";

import { newVehicles, vehicles } from "../../constants/vehicleData";
const CustomerVehiclesPage = styled(Box)(({ theme }) => ({
  width: "100vw",
  display: "flex",
  alignItems: "center",
  minHeight: "500px",
  flexDirection: "column",
  paddingLeft: "8%",
  paddingRight: "8%",
  ".vehicles-grid-container": {
    padding: "0",
    display: "flex",
    justifyContent: "flex-start",
  },
  ".search-result-heading": {
    justifyContent: "flex-start",
    alignSelf: "flex-start",
    paddingLeft: "5px",
    marginBottom: "5px",
    letterSpacing: "1px",
  },

  ".brand-name-head": {
    fontSize: "31px",
    fontWeight: "600",
    lineHeight: "50px",
    letterSpacing: "0em",
    marginBottom: "8px",
    paddingLeft: "2px",
    textAlign: "left",
    textTransform: "capitalize",
  },
  ".promiseHeader": {
    fontSize: "24px",
    fontWeight: "700",
    letterSpacing: "0em",
    textAlign: "left",
  },
  [theme.breakpoints.down("md")]: {
    padding: "10px",
  },
  [theme.breakpoints.down("sm")]: {
    ".promiseHeader": {
      fontSize: "24px",
    },
    ".brand-name-head": {
      position: "relative",
      top: "0px",
      paddingLeft: "8px",
      marginBottom: "20px",
    },
  },
  ".promiseHeader": {
    fontSize: "24px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "10px",
  },
  [theme.breakpoints.down("sm")]: {
    ".promiseHeader": {
      fontSize: "24px",
    },
    ".brand-name-head": {
      position: "relative",

      top: "0px",
      paddingLeft: "12px",
      marginBottom: "20px",
    },
  },
}));

const Vehicles = ({ vehiclesByBrand }) => {
  const { showWhatsappPopup } = useContext(Context);
  const brandOrder = [
    "mahindra",
    "bajaj",
    "piaggio",
    "euler",
    "montra",
    "osm",
    "greaves",
  ];
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const state = useContext(Context);
  const { searchValue } = state;
  const newVehiclesArray = [
    "Tuoro max++",
    "Rage + Frost",
    "Rage + 10.8 Kwh",
    "Rage + 8.5  Kwh",
    "HiLoad DV 130 Cu. Ft",
    "HiLoad DV 170 Cu. Ft",
    "HiLoad PV",
    "Zor Grand",
    "E-Xtra FX Max",
    "Altigreen neEV",
  ]; //required for rendering the new vehicles pop up

  let cacheInfoSlider = getCookie("user_slided")
    ? JSON.parse(getCookie("user_slided"))
    : "";
  let cacheInfoUser = getCookie("user_verified")
    ? JSON.parse(getCookie("user_verified"))
    : "";

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      localStorage?.getItem("phoneInfo") === null &&
      cacheInfoSlider?.slided === true &&
      cacheInfoUser?.verified !== true
    ) {
      showWhatsappPopup("Image_slided");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Helper function to sort vehicles: passenger first, then cargo
  const sortVehiclesByType = (vehiclesList) => {
    if (!vehiclesList || vehiclesList.length === 0) return vehiclesList;
    
    return [...vehiclesList].sort((a, b) => {
      const aType = Array.isArray(a.type) ? a.type : [a.type];
      const bType = Array.isArray(b.type) ? b.type : [b.type];
      
      const aIsPassenger = aType.includes("passenger");
      const bIsPassenger = bType.includes("passenger");
      const aIsCargo = aType.includes("cargo");
      const bIsCargo = bType.includes("cargo");
      
      // Passenger vehicles come first
      if (aIsPassenger && !bIsPassenger) return -1;
      if (!aIsPassenger && bIsPassenger) return 1;
      
      // If both are passenger or both are cargo, maintain original order
      return 0;
    });
  };

  // this useeffect will work whenever there is any change in the searchvalue
  useEffect(() => {
    const allVehicles = [...vehicles, ...newVehicles]; //storing new and old vehicles in the all Vehilces
    if (searchValue?.length !== 0) {
      const tempVehicles = allVehicles?.filter((vehicle) => {
        return (
          vehicle.vehicle_name
            .toLowerCase()
            .includes(searchValue?.toLowerCase()) ||
          vehicle?.brand?.toLowerCase().includes(searchValue?.toLowerCase())
        );
      });
      setFilteredVehicles(tempVehicles);
    }
    // eslint-disable-next-line
  }, [searchValue]);

  return (
    <CustomerVehiclesPage>
      <Grid
        container
        spacing={3}
        className="vehicles-grid-container"
        id="search-result"
      >
        {searchValue === undefined || searchValue?.length === 0 ? (
          <>
            {brandOrder?.map((brand, index) => {
              if (vehiclesByBrand[brand?.toLowerCase()]?.length > 0) {
                return (
                  <React.Fragment key={brand}>
                    {/* promises component - shows after Piaggio (before Euler, index 3) */}
                    {index === 3 && (
                      <>
                        <Grid item xs={12}>
                          <Typography
                            variant="h2"
                            className="promiseHeader"
                            sx={{
                              padding: { xs: "0 15px", md: "0" },
                              fontSize: { xs: "24px", md: "24px" },
                              fontWeight: "700 !important",
                            }}
                          >
                            Why Turno for Commercial Electric Vehicles?
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                          <TurnoPromiseComponent />
                        </Grid>
                      </>
                    )}
                    {/* loanComponent - shows after Montra (before OSM, index 5) */}
                    {index === 5 && (
                      <React.Fragment>
                        <Grid item xs={12}>
                          <VehicleLoan />
                        </Grid>
                      </React.Fragment>
                    )}

                    {/* vehicles component */}
                    <Grid item xs={12}>
                      <Typography variant="h2" className="brand-name-head">
                        {brand}
                      </Typography>
                    </Grid>

                    {sortVehiclesByType(vehiclesByBrand[brand?.toLowerCase()])?.map(
                      (item, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                          <MemoizedCustomerVehicleCard
                            vehicleData={item}
                            isNewVehicle={newVehiclesArray?.includes(
                              item?.vehicle_name
                            )}
                            ctaText={`Get On-road Price`}
                          />
                        </Grid>
                      )
                    )}
                  </React.Fragment>
                );
              }

              return null;
            })}
          </>
        ) : (
          <>
            <Grid item xs={12} sx={{ fontSize: { xs: "20px", lg: "28px" } }}>
              <Typography variant="p" className="search-result-heading">
                <Typography
                  variant="span"
                  style={{ fontWeight: "600", marginRight: "4px" }}
                >
                  {filteredVehicles?.length}
                </Typography>
                vehicles |
                <Typography
                  variant="span"
                  style={{ color: primary.main, fontWeight: "600" }}
                >
                  TURNO
                </Typography>
              </Typography>
            </Grid>
            {filteredVehicles?.map((item, index) => {
              return (
                <>
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <MemoizedCustomerVehicleCard
                      vehicleData={item}
                      isNewVehicle={newVehiclesArray?.includes(
                        item?.vehicle_name
                      )}
                      ctaText={`Get On-road Price`}
                    />
                  </Grid>
                </>
              );
            })}
          </>
        )}
      </Grid>
    </CustomerVehiclesPage>
  );
};

export const MemoizedVehicles = React.memo(Vehicles);
